<template>
  <div class="auth-layout-wrap mt-4 mt-md-0">
    <div class="auth-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
};
</script>
<style scoped></style>
